import { http } from './config'

export default {
  listarbandeiras:() => {
    return http.get('bandeira.php')
  }
}